<template>
  <div class="pay-method">
    <div class="flex-1">
      <a-segmented
        v-if="props.buyType !== BUY_TYPE.SUBSCRIBE"
        class="pay-method__methods"
        block
        :value="payType"
        :options="data"
        @change="onChange"
      >
        <template #label="{ title }">{{ title }}</template>
      </a-segmented>
      <!-- firefox 会出现滚动条 -->
      <div :class="['block mx-auto overflow-hidden', iframeClass]">
        <div
          v-if="!agreementChecked"
          class="flex flex-col justify-center items-center gap-[2px] h-full bg-font-80 check-agreement"
        >
          <iconpark-icon name="iconwarn" class="text-[24px]"></iconpark-icon>
          <div class="text-[#fff] font-[12px] leading-[18px]">
            {{ $t('qing-xian-gou-xuan-xia-fang-xie-yi') }}
          </div>
        </div>
        <div
          v-else-if="loading || iframeLoading"
          class="w-full h-[130px] bg-font-80 rounded-[8px] grid place-items-center"
        >
          <LoadingOutlined />
        </div>
        <!-- 指定了码的大小，但是支付宝页面内元素高度多了 4px -->
        <iframe
          v-else-if="showAlipay"
          scrolling="no"
          :src="qrcode.alipay"
          frameborder="0"
          @loadstart="() => (iframeLoading = true)"
          @load="() => (iframeLoading = false)"
        />
        <ClientOnly v-else>
          <XQrcode :url="qrcode.weixin" :size="130" class="wechat-qrcode" />
        </ClientOnly>
      </div>
      <div class="pay-method__tip">{{ tipText }}</div>
      <PayPrice
        :text="priceText"
        :expiredDate="expiredDate"
        class="mt-[20px]"
      />
    </div>
    <PayAgreement
      :checked="agreementChecked"
      :buyType="buyType || BUY_TYPE.PAYMENT"
      @checked="onChecked"
    />
    <slot></slot>
  </div>
</template>

<script setup lang="ts" name="PayQrcode">
import PayPrice from './pay-price.vue'
import PayAgreement from './pay-agreement.vue'
import TitleLabel from './titleLabel/index.vue'
import { BUY_TYPE, PAY_TYPE } from '~/api/interface/rights'
import XQrcode from '~/components/xQrcode/index.vue'
import { PAY_TYPE_MAP } from '~/constants'

const props = defineProps<{
  payType: PAY_TYPE
  buyType?: BUY_TYPE
  agreementChecked: boolean
  loading: boolean
  qrcode: {
    weixin: string
    alipay: string
  }
  priceText: number
  expiredDate?: string
}>()
const emits = defineEmits(['update:payType', 'update:agreementChecked'])
const { $t } = useNuxtApp()
const iframeLoading = ref(false)

const data = computed(() => {
  const buyTypes = [
    { title: PAY_TYPE_MAP().get(PAY_TYPE.ALIPAY), value: PAY_TYPE.ALIPAY },
  ]
  // if (props.buyType !== BUY_TYPE.SUBSCRIBE) {
  //   buyTypes.push({
  //     title: PAY_TYPE_MAP().get(PAY_TYPE.WEIXIN),
  //     value: PAY_TYPE.WEIXIN,
  //   })
  // } todo: 暂时关闭微信支付
  return buyTypes
})

const isAlipay = computed(() => props.payType === PAY_TYPE.ALIPAY)

const showAlipay = computed(() => isAlipay.value && props.qrcode.alipay)

const iframeClass = computed(() => {
  return props.buyType !== BUY_TYPE.SUBSCRIBE
    ? 'panel-payment'
    : 'panel-subscribe'
})

const tipText = computed(() =>
  isAlipay.value
    ? $t('qing-shi-yong-zhi-fu-bao-sao-ma-zhi-fu')
    : $t('qing-shi-yong-wei-xin-sao-ma-zhi-fu')
)

function onChange(value: any) {
  emits('update:payType', value)
}

function onChecked(checked: boolean) {
  emits('update:agreementChecked', checked)
}
</script>

<style lang="scss" scoped>
.panel {
  &-subscribe {
    position: relative;
    width: 140px;
    height: 140px;
    margin: 44px auto 8px;
    iframe {
      width: 300px;
      height: 400px;
      transform: scale(0.76);
      position: absolute;
      left: -80px;
      top: -185px;
    }
  }
  &-payment {
    width: 140px;
    border-radius: 8px;
    padding: 5px;
    height: 140px;
    margin-bottom: 8px;
    background-color: var(--back-2);

    .check-agreement {
      min-height: 130px;
    }
    .wechat-qrcode {
      border-radius: 6px;
    }
    iframe {
      width: 150px;
      height: 150px;
      transform: scale(0.8666) translate(-12px, -10px);
      border-radius: 6px;
    }
  }
}
.pay-method {
  display: flex;
  flex-direction: column;
  padding: 20px;
  width: 270px;
  &__title {
    padding-top: 16px;
    font-size: 14px;
    line-height: 24px;
    opacity: 0.6;
  }
  &__methods {
    margin: 0px auto 16px;
    width: 216px;
  }
  &__tip {
    padding-bottom: 6px;
    font-size: 12px;
    line-height: 1;
    text-align: center;
    opacity: 0.5;
  }
  &__protocol {
    font-size: 12px;
    opacity: 0.5;
  }
}
</style>
